<template>
  <el-dialog title="라이센스 삭제"
    :visible.sync="value"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="30%"
  >
    <div>
      라이센스 이력을 삭제하시겠습니까?
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">취소</el-button>
      <el-button type="danger" @click="submitForm">확인</el-button>
    </span>
  </el-dialog>

</template>

<script>
export default {
  props: ['value', 'license'],
  methods: {
    submitForm () {
      this.$emit('close', this.license)
    },
    close () {
      this.$emit('close')
    }
  },
  data () {
    return {
    }
  }
}
</script>
